import { render, staticRenderFns } from "./ProductQrcode.vue?vue&type=template&id=624657c0&scoped=true&"
import script from "./ProductQrcode.vue?vue&type=script&lang=js&"
export * from "./ProductQrcode.vue?vue&type=script&lang=js&"
import style0 from "./ProductQrcode.vue?vue&type=style&index=0&id=624657c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624657c0",
  null
  
)

export default component.exports